import '../..//css/body/contact.css';
import { SectionProps } from '../shared/SectionProps';

export const Contact = (props: SectionProps) => {
   return (
      <div id={props.id} className="section contact-conatiner p-0 m-0 pt-5 text-center">
         <div className="contact-text-container pt-5 px-5">
            <h2>Kontakt</h2>
            <div className="d-flex flex-wrap justify-content-around py-5 text-start">
               <div className="pb-5 contact-call-texts d-flex align-items-center">
                  <div>
                     <i className="bi bi-file-text contact-offer-icon-size me-4"></i>
                  </div>
                  <div>
                     <span className="contact-call-text pb">Zadzwoń, żeby poznać naszą <b>ofertę</b>!</span>
                     <br className="my-3" />
                     <span className="contact-opening-hrs-text">Jesteśmy dla Ciebie dostępni w <u>dni robocze</u> w godzinach <u>7:00 - 15:00</u>.</span>
                  </div>
               </div>
               <div className="pt-4 pb-5">
                  <a href="tel:+48815029218" className="btn contact-call-phone py-3">
                     <span className="contact-call-phone-text">
                        <i className="bi bi-telephone-fill me-3"></i><b>81 502 92 18</b>
                     </span>
                  </a>
               </div>
            </div>
         </div>
         <div className="d-none d-xl-block">
            <svg viewBox="0 0 500 50" transform='rotate(180)' className="m-0 p-0 wave">
               <path fill="#282c34" d="M 0 10 C 300 110 225 -50 500 42 L 500 0 L 0 0"></path>
            </svg>
         </div>
       </div>
   );
}